import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 用户名密码注册
interface OrderPlaceJson {
	uid: string,
	role_id: string,
	role_name: string,
	trade_no: string,
	server_id: string,
	price: string,
	pay_way: number,
	payplatform2cp: string,
	props_name: string,
	server_name: string,
	openid: string,
}
export const orderPlace = (json: OrderPlaceJson): any => http.httpPost({
	url: httpApi.pay.orderPlace,
	json,
})

// 订单查询
interface PayResultJson {
	order_no: string
}
export const payResult = (json: PayResultJson): any => http.httpPost({
	url: httpApi.pay.payResult,
	json
})

// 获取支付扫码二维码
interface GetUserQrcodeJson {
	order_no: string,
	type: number
}
export const getUserQrcode = (json: GetUserQrcodeJson): any => http.httpPost({
	url: httpApi.pay.getUserQrcode,
	json
})
